import { AlertSeverity, IAlertSeverity } from "./AlertSeverity";
import { BannerType, IBannerType } from "./BannerType";

export interface IBanner {
    bannerId: string;
    bannerType: IBannerType;
    severity: IAlertSeverity;
    title: string;
    message: string;
    effectiveStartDate: Date;
    effectiveEndDate: Date;
}

export class Banner implements IBanner {
    public bannerId: string;
    public bannerType: BannerType;
    public severity: AlertSeverity;
    public title: string;
    public message: string;
    public effectiveStartDate: Date;
    public effectiveEndDate: Date;
}
